import { useFormik } from "formik";
import { useCallback, useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import DatePicker from "react-date-picker";
import { useQueryClient } from "react-query";
import ConfirmWithLoader from "../../../../Components/Modals/ConfirmWithLoader"
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { GetBancoListHabilitadosxCartaFianza } from "../../../../api/Api";
import './ChequeGarantiaModal.css';

export default function ChequeGarantiaModal({
  showModal = false,
  setShowModal,
  isFinishSave = false,
  onConfirm,
  onClose,
  messageError,
  title,
  value
}) {
  const [isLoadingSave, setIsLoadingSave] = useState(true);

  const [bancosOptions, setBancosOptions] = useState([]);

  const queryClient = useQueryClient();

  const { values: formikValues,
    setFieldValue: setFormikFieldValue,
    handleSubmit: handleSubmitFormik } = useFormik({
      initialValues: {
        banco: value?.banco?.value ? value.banco : null,
        nroCheque: value?.nroCheque || "",
        fecha: value?.fecha || null
      },
      enableReinitialize: true,
      onSubmit: (values) => {
        setIsLoadingSave(true);
        onConfirm && onConfirm(values);
      }
    })

  useEffect(() => {
    if (showModal) {
      queryClient.fetchQuery('getBancoListHabilitadosxCartaFianza', GetBancoListHabilitadosxCartaFianza).then((result) => {
        if (result.success) {
          const options = result.data.map(item => ({
            value: item.id_banco,
            label: item.codigo
          }));
          setBancosOptions(options);
        }

      }).catch((err) => {
      }).finally(() => {
        setIsLoadingSave(false);
      });
    }
  }, [showModal, queryClient])

  const validateButtonConfirm = useCallback(() => {
    return !(formikValues.fecha && formikValues.banco && formikValues.nroCheque.length > 0)
  }, [formikValues.banco, formikValues.fecha, formikValues.nroCheque])

  const handleClose = useCallback(() => {
    setIsLoadingSave(true);
    onClose && onClose();
  }, [onClose])

  useEffect(() => {
    if (isFinishSave) {
      setIsLoadingSave(false);
    }
  }, [isFinishSave])

  const validateNumberInput = useCallback((event) => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }, [])

  return (
    <>
      <ConfirmWithLoader
        showModal={showModal}
        setShowModal={setShowModal}
        title={title}
        isLoading={isLoadingSave}
        isFinish={isFinishSave}
        disabledConfirmButton={validateButtonConfirm()}
        hideContentInLoading={false}
        hideActionAfterConfirm={false}
        textButtonCancel={"Cerrar"}
        textButton={"Guardar"}
        onConfirm={() => handleSubmitFormik()}
        onClose={handleClose}
      >
        {!isLoadingSave && isFinishSave && (
          messageError ? (
            <Alert key='error' variant='primary' className='mb-8'>
              <b>Error</b>: {messageError}
            </Alert>
          ) : (
            <Alert key='info' variant='success' className='mb-8'>
              <b>Registro de cheque</b>: El cheque se ha guardado exitosamente.
            </Alert>
          )
        )}
        <div className="container">
          <div className="row">
            <div className="col-12 d-flex align-items-center">
              <label className="fw-bold fs-6 me-4 label-form-cheque text-end">Banco:</label>
              <Select
                classNamePrefix='filter'
                components={makeAnimated()}
                value={formikValues.banco}
                options={bancosOptions}
                isMulti={false}
                closeMenuOnSelect={true}
                placeholder="Selecciona"
                className="flex-grow-1 w-auto"
                isSearchable={false}
                onChange={(value) => { setFormikFieldValue(`banco`, value) }}
              />
            </div>
            <div className="col-12 d-flex align-items-center mt-4">
              <label className="fw-bold fs-6 me-4 label-form-cheque text-end">Nro Cheque:</label>
              <input type="text"
                className="form-control form-control-solid flex-grow-1 w-auto"
                value={formikValues.nroCheque}
                onChange={(e) => { setFormikFieldValue(`nroCheque`, e.target.value) }}
                onKeyPress={validateNumberInput}
              />
            </div>
            <div className="col-12 d-flex align-items-center mt-4">
              <label className="fw-bold fs-6 me-4 label-form-cheque text-end">Fecha de entrega:</label>
              <DatePicker
                className="form-control form-control-solid flex-grow-1 w-auto"
                locale="es"
                value={formikValues.fecha}
                dateFormat="dd/MM/yyyy"
                shouldCloseOnSelect={false}
                onChange={(date) => setFormikFieldValue(`fecha`, date)}
              />
            </div>
          </div>
        </div>


      </ConfirmWithLoader>
    </>
  )
}